export enum RequestStatus {
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    REJECTED = 'REJECTED',
    IN_PROGRESS = 'IN_PROGRESS',
    INPROGRESS = 'INPROGRESS',
    CANCELLED = 'CANCELLED',
    CANCELLED1 = 'CANCELLED1',
    CLOSED = 'CLOSED',
    APPROVED = 'APPROVED',
    COMPLETED = 'COMPLETED'
}

export enum PaymentRequestStatus {
    PENDING = 'Pending',
    NOTPAID = 'NotPaid',
    PAID = 'Paid'
}

export enum ReceiptAllocationStatus {
    ALLOCATED = 'Allocated'
}

export type FilterEnum<T> = T | 'ALL';

export enum LatestRequestType {
    GeneralRequest = 'General Request',
    PaymentRequest = 'Cash Movement Request',
    AccountChange = 'Account Change',
    KYB = 'New KYB submission',
    RiskLimit = 'Risk Limit',
    Receipt = 'Receipt'
}

export enum RequestStatusType {
    ALL = 'ALL',
    COMPLETE = 'COMPLETE',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELLED = 'CANCELLED'
}

export enum CashMovementStatusType {
    ALL = 'ALL',
    PENDING = 'Pending',
    NOTPAID = 'NotPaid',
    PAID = 'Paid',
    ALLOCATED = 'Allocated'
}

export enum CashMovementActivityTypeFilter {
    ALL = 'ALL',
    PAYMENT_REQUEST = 'PaymentRequest',
    RECEIPT = 'Receipt'
}

export enum RequestType {
    ALL = 'ALL',
    MY_REQUESTS = 'MY_REQUESTS'
}

export const REQUEST_STATUS_OPTIONS = [
    {
        title: 'All statuses',
        value: RequestStatusType.ALL
    },
    {
        title: 'Pending',
        value: RequestStatusType.PENDING
    },
    {
        title: 'In progress',
        value: RequestStatusType.IN_PROGRESS
    },
    {
        title: 'Complete',
        value: RequestStatusType.COMPLETE
    },
    {
        title: 'Cancelled',
        value: RequestStatusType.CANCELLED
    },
    {
        title: 'Rejected',
        value: RequestStatusType.REJECTED
    }
];

export const CASH_MOVEMENT_REQUEST_STATUS_OPTIONS = [
    {
        title: 'All statuses',
        value: CashMovementStatusType.ALL
    },
    {
        title: 'Pending',
        value: CashMovementStatusType.PENDING
    },
    {
        title: 'Paid',
        value: CashMovementStatusType.PAID
    },
    {
        title: 'Unpaid',
        value: CashMovementStatusType.NOTPAID
    },
    {
        title: 'Allocated',
        value: CashMovementStatusType.ALLOCATED
    }
];

export const CASH_MOVEMENT_ACTIVITY_TYPE_OPTIONS = [
    { title: 'All activity', value: CashMovementActivityTypeFilter.ALL },
    { title: 'Payments', value: CashMovementActivityTypeFilter.PAYMENT_REQUEST },
    { title: 'Receipts', value: CashMovementActivityTypeFilter.RECEIPT }
];

export enum RequestAction {
    ADD = 'ADD',
    UPDATE = 'UPDATE',
    RISK_LIMIT_UPDATE = 'RISK_LIMIT_UPDATE',
    DELETE = 'DELETE'
}

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

export enum TabValue {
    ALL = 'all',
    LATEST = 'latest'
}

export const MFA_REQUIRED = 'MFARequiredException';

export enum OfficeName {
    UK = 'UK',
    US = 'US',
    APAC = 'APAC',
    UAE = 'UAE'
}

export enum OpenState {
    ForceOpen = 'ForceOpen',
    ForceClose = 'ForceClose',
    Schedule = 'Schedule'
}
export interface Office {
    id: number;
    openState: OpenState;
    openingHours: string;
    closingHours: string;
    name: OfficeName;
    standardTimezone: string;
    isOpen: boolean;
    statusMessage: string;
    shouldCheckFunds: boolean;
}

export enum RegulatoryReportingDescription {
    SECURED = '30.7 Secured Funds',
    SEGREGATED = 'Segregated Funds'
}

export type BreachedState = 'NA' | 'YES' | 'NO';
